var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from "react";
import http from "../core/http.js";
import { isEmail } from "../core/password.js";
export const useEmailCode = ({ t, action, email, locale, showError, }) => {
    const [count, setCount] = useState(0);
    const [sent, setSent] = useState(false);
    const timerRef = useRef(null);
    /**
     * 验证邮箱是否已注册
     * @param mail 邮箱地址
     */
    const fetchExist = (mail) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const params = new URLSearchParams({ user_name: mail });
            const response = yield http.get(`/usercenter/4.0/check_exist?${params}`, {
                showOriginResponse: true,
                getLang: () => locale,
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
                return response.data.exist;
            }
            throw new Error(response === null || response === void 0 ? void 0 : response.msg);
        }
        catch (errorInfo) {
            const msg = typeof errorInfo === "string" ? errorInfo : errorInfo.message;
            showError({
                type: "error",
                content: msg || "unknown error",
            });
        }
    });
    /**
     * 倒计时
     */
    const setCountDown = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        setCount(60);
        timerRef.current = window.setInterval(() => {
            setCount((prevCount) => {
                if (prevCount <= 1) {
                    if (timerRef.current) {
                        clearInterval(timerRef.current);
                        timerRef.current = null;
                    }
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);
    };
    /**
     * 验证码查询
     */
    const fetchVerifyCode = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!email) {
                return;
            }
            setCountDown();
            const formData = new FormData();
            formData.append("code_type", action === "register" ? "register_account" : "reset_account");
            formData.append("email", email.trim());
            formData.append("source", "metal.multi");
            formData.append("language", locale);
            const response = yield http.post(`/usercenter/english/v1/send_email_code`, {
                body: formData,
                showOriginResponse: true,
                getLang: () => locale,
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
                setTimeout(() => setSent(true), 1000);
            }
            else {
                throw new Error(response === null || response === void 0 ? void 0 : response.msg);
            }
        }
        catch (errorInfo) {
            const msg = typeof errorInfo === "string" ? errorInfo : errorInfo.message;
            showError({ type: "error", content: msg || "unknown error" });
        }
    });
    /**
     * 发送验证码
     */
    const sendCode = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!email || count > 0)
            return;
        if (!isEmail(email)) {
            showError({ type: "error", content: t(action === "register" ? "register.validEmail" : "forgot.validEmail") });
            return;
        }
        const isExist = yield fetchExist(email);
        if (action === "forgot" && isExist === true) {
            yield fetchVerifyCode();
        }
        if (action === "forgot" && isExist === false) {
            showError({ type: "error", content: t("forgot.email_toast") });
        }
        if (action === "register" && isExist === false) {
            yield fetchVerifyCode();
        }
        if (action === "register" && isExist === true) {
            showError({ type: "error", content: t("register.alreadyAccount") });
        }
    });
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);
    return { fetchCode: sendCode, sendCode, count, sent };
};
//# sourceMappingURL=useEmailCode.js.map